export const styles = {
  innerWrapper: 'p-0 &:hover:border-content1-200 [&>button]:bg-primary',
  trigger: 'after:hidden border-success hover:border-success !px-[12px]',
  popoverContent: 'rounded-medium bg-content1-200',
  selectorIcon: 'h-[18px] w-[30px] text-success',
}

export const stylesOption = {
  base: 'data-[hover=true]:bg-success data-[hover=true]:text-primary',
}
